<template>
<div class="intro"
  @click="clickOverlay()">
  <div class="intro-title top-center"
    v-bind:class="{ animated: animated }"
    v-if="showTitle || !animated">
    The Colaizzo Wedding is Coming
  </div>
  <font-awesome-icon :icon="['far', 'play-circle']"
    class="play-button"
    @click.stop="play()"
    v-if="requiresAction" />
  <div class="rsvp-button cta"
    v-if="showRSVP || completed"
    v-bind:class="{ animated: animated }"
    @click="clickRSVP()">
    ENTER
  </div>
  <div class="volume-anchor"
    @click.stop="toggleVolume()"
    v-if="playing">
    <font-awesome-icon v-if="!muted"
      icon="volume-up" />
    <font-awesome-icon v-else
      icon="volume-off" />
  </div>
  <div v-if="playing && !completed"
    class="skip-button bottom-middle cta"
    @click.stop="skip()">
    Skip
  </div>
  <div class="intro-sub-title bottom-left"
    v-bind:class="{ animated: animated }"
    v-if="showDate || !animated">
    October 12, 2019
  </div>
  <div class="intro-sub-title bottom-right"
    v-bind:class="{ animated: animated }"
    v-if="showCity || !animated">
    Montara, CA
  </div>
</div>
</template>

<script>
import {
  Howl,
  Howler
} from 'howler';

const DELAY_IN_MS = 4000;

export default {
  name: 'HelloWorld',
  data() {
    return {
      requiresAction: true,
      animated: true,
      playing: false,
      showDate: false,
      showCity: false,
      showTitle: false,
      showRSVP: false,
      muted: false,
      completed: false,
    }
  },
  mounted: function () {
    this.sound = new Howl({
      src: ['/stranger_things_39.mp3'],
      onplay: this.onPlaybackStarted,
      onend: this.onPlaybackEnded,
      onstop: this.onPlaybackEnded,
    });
  },
  methods: {
    play: function () {
      var self = this;

      self.requiresAction = false;

      self.sound.play();

      self.showDate = true;

      setTimeout(function () {
        self.showCity = true;
        setTimeout(function () {
          self.showTitle = true;
          setTimeout(function () {
            self.showRSVP = true;
          }, DELAY_IN_MS * 2);
        }, DELAY_IN_MS);
      }, DELAY_IN_MS);
    },
    toggleVolume: function () {
      this.muted = !this.muted;

      this.sound.mute(this.muted);
    },
    onPlaybackStarted: function () {
      this.playing = true;
      console.log('Starting intro music');

      var self = this;
      setTimeout(function () {
        self.sound.fade(1, 0, 5000);
        console.log('Fading out intro music');
      }, 34 * 1000);
    },
    onPlaybackEnded: function () {
      this.playing = false;
    },
    skip: function () {
      var self = this;

      this.sound.fade(1, 0, 5000);
      this.sound.once('fade', function () {
        self.sound.stop();
      });

      this.animated = false;
      this.completed = true;
    },
    clickOverlay: function () {
      if (this.requiresAction) {
        this.play();
      } else {
        if (this.playing) {
          this.skip();
        }
      }
    },
    clickRSVP: function () {
      this.$emit('clickedRSVP');
    }
  }
}
</script>

<style>
.intro {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  overflow: hidden;
}

@font-face {
  font-family: 'Mexcellent3d';
  src: url('../assets/fonts/mexcel3D.ttf') format('truetype');
}

@keyframes title-animation {
  from {
    transform: perspective(200px) translateZ(300px);
  }
  to {
    transform: perspective(200px) translateZ(0px);
  }
}

@-webkit-keyframes slide-in-right {
  0% {
    transform: translateX(1000px);
  }
  100% {
    transform: translateX(0);
  }
}

.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.intro-title,
.intro-sub-title {
  font-family: 'Mexcellent3d' !important;
  color: white !important;
}

.intro-title {
  font-size: 3em;
}

.intro-sub-title {
  font-size: 1.6em;
}

.intro-title.animated,
.intro-sub-title.animated {
  animation-name: title-animation;
  animation-duration: 10s;
  animation-fill-mode: forwards;
}

.skip-button {
  color: white;
  cursor: pointer;
  opacity: 0.5;
  z-index: 3;
}

.play-button {
  color: white;
  font-size: 7em;
  cursor: pointer;

  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.rsvp-button {
  color: white;
  font-size: 5em;
  cursor: pointer;

  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media (max-width: 600px),
(max-height: 600px) and (orientation:landscape) {
  .intro-sub-title {
    font-size: 1em;
  }
  .rsvp-button {
    margin-top: 2.2em;
    font-size: 3em;
  }
}

.volume-anchor {
  position: absolute;
  top: 0;
  right: 0;
  padding: 1em;
  font-size: 1.2em;
  cursor: pointer;
  z-index: 3;
}

.skip-container {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.top-center {
  position: absolute;
  top: 0;
  padding: 1em;
  text-align: center;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto
}

.cta {
  padding: 0.4em 0.8em;
  border: 1px solid white;
}

.bottom-middle {
  position: fixed;
  left: 50%;
  bottom: 5em;
  transform: translate(-50%, -50%);
  margin: 0 auto;
}

.bottom-right {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 1em;
}

.bottom-left {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 1em;
}
</style>
